import * as React from "react";
import AiAccordion from "./Ai/Ai";
import MgmtAccordion from "./Mgmt/mgmt";
import SnaAccordion from "./Sna/sna";
import MechAccordion from "./Mech/mech";
import ResearchAIAccordion from "./Research AI/ResearchAI";


export default function SimpleAccordion() {
  return (
    <div
      className="challenges"
      style={{ backgroundColor: "#071013", color: "white" }}
    >
      <div className="challenge-intro">
        <h1 className="black" style={{ color: "#f49221"}}>
          Recruitment <span className="orange">Challenges</span>
        </h1>
        
        <p className="black" style={{ color: "#ffffff" }}>
          Project MANAS brings you the opportunity to fast-track into the
          TaskPhase by competing in the Recruitment Challenges.
          <br />
          <b>
            MIT Students only from first year are eligible to apply for the same
          </b>
          .
          <br />
          <br />
          Eligible students can attempt the questions belonging to any division
          without requiring any pre-requisites.
          <br />
          <br />
          You are <b>recommended to apply for the interviews</b>, over{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeNcbiQ5Od7yBgPGxPezvKWrOgYWL69-whGDMGfe9Zb8F99mQ/viewform"
          >
            here
          </a>
          , regardless of your submission of the Recruitment Challenge.
        </p>
        <p className="black" style={{ color: "#ffffff" }}>
          The deadline for the Recruitment Challenges of all divisions is{" "}
          <h3 style={{ color: "white" }}>
           <b>31st August 2026 at 11:59 PM.</b>
          </h3>
        </p>
        <p className="black" style={{ color: "#ffffff" }}>
          <h3 style={{ color: "white" }}>
            <b>Partial submissions are also encouraged.</b>
          </h3>
        </p>
        <p className="black" style={{ color: "#ffffff" }}>
          Recruitment Challenges is one of the ways to get into the Taskphase. Alternatively, you can choose to apply directly for the interviews.
          
        </p>
      </div>
      <div>
        <AiAccordion />
<SnaAccordion />
<MechAccordion />
<MgmtAccordion />
<ResearchAIAccordion />
        

 
      </div>
    </div>
  );
}
